import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?is_seasonal=0&${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("filter")}${getParams("sort_by")}&sort_order=${
          params?.sort_order || "desc"
        }&per_page=${params?.per_page || "10"}&${getParams("search")}page=${
          params?.page || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const nonSeasonalOffers = createApi({
  reducerPath: "nonSeasonalOffersApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["non-seasonal-offer"],
  endpoints: (builder) => ({
    getNonSeasonalData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/offer/list`,
      }),
      providesTags: ["non-seasonal-offer"],
    }),
    updateTableFeildsData: builder.mutation({
      query(body) {
        return {
          endpoint: `/v1/admin/table-permission-create`,
          method: 'post',
          body,
        }
      },
      invalidatesTags: ["non-seasonal-offer"],
    }),
    getSizeData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/size-type/active-size-type`,
      }),
      providesTags: ["non-seasonal-offer"],
    }),
    getFrameData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/frame-type/active-frame-type`,
      }),
      providesTags: ["non-seasonal-offer"],
    }),
    getRuleData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/offer/rule-list`,
      }),
      providesTags: ["non-seasonal-offer"],
    }),
    updateStatusById: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `v1/admin/offer/change-status`,
      }),

      // invalidatesTags: ["non-seasonal-offer"],
    }),
  }),
});

export const { useGetNonSeasonalDataQuery,useUpdateTableFeildsDataMutation, useGetSizeDataQuery, useGetFrameDataQuery, useUpdateStatusByIdMutation, useGetRuleDataQuery } = nonSeasonalOffers;
